import React, { Component } from 'react'
import T from '../translate/T'

import BoxScroll from '../atoms/BoxScroll'
import Link from '../atoms/Link'
import Avatar from '../atoms/Avatar'
import If from '../atoms/If'

import { getNotifications, markNotificationToRead } from '../utils.js'
import style from './style.css'

class UserNotifications extends Component {
    state = {
        notification: null
    }
    
    constructor(props) {
        super(props)
        this.handleOver = this.handleOver.bind(this)
        this.handleOut = this.handleOut.bind(this)
    }

    componentWillMount() {
        getNotifications()
        .then( data => {
            this.setState({
                notification: data
            })
        })
        
        // this.interval = setInterval(function() {
        //     this.props.getNotifications(this.props.notification.startIn)
        // }.bind(this), 10000)
    }

    componentWillUpdate(np, ns) {
        if( ns.notification && ns.notification !== this.state.notification ) 
            this.props.handleUnreadNotifications( ns.notification.unread )    
    }

    // componentWillUnmount() {
        // clearInterval(this.interval)
    // }

    // componentWillReceiveProps( nextProps ) {
        // if(nextProps.notification.unread && this.props.notification.unread !== nextProps.notification.unread)
        //     this.props.handleUnreadNotifications( nextProps.notification.unread )
    // }

    handleOut() {
        clearTimeout(this.timeoutId)
    }

    handleOver(e, id) {
        this.timeoutId = setTimeout(function() {
         
            
            let result = this.state.notification.result
            let item = result.find( notification => notification.id == id)
            
            let inx = result.indexOf(item)
            
            result[inx].status = 'read'

            this.setState({
                notification: {
                    ...this.state.notification,
                    unread: this.state.notification.unread - 1,
                    result
                }
            })

            markNotificationToRead(id)
            .then( data => {} )
        }.bind(this), 300)
    }

    render() {
        const renderList = () => {
            return this.state.notification.result.map(item => (
                <Link key={item.id} href={item.link} full>
                    <div
                        onMouseOver={(e) => {
                            if(item.status !== 'read') this.handleOver(e, item.id)
                            }}
                        onMouseOut={this.handleOut}
                        className={`${style.item} ${(item.status === 'send') ? style.unread : ''}`}
                    >
                        <If test={item.image !== ''}>
                            <Avatar style={{
                                float: 'left'
                            }} img={`${item.image}`} size='26' />
                            <span className={style.text} dangerouslySetInnerHTML={{__html: item.description}} />
                        </If>

                        <If test={item.image === ''}>
                            <span dangerouslySetInnerHTML={{__html: item.description}} />
                        </If>
                    </div>
                </Link>
            ))
        }

        return (
            <div className={style.boxNotification}>
            <BoxScroll height='400px' auto>
                <div className={style.items}>
                    {
                        (this.state.notification && !this.state.notification.unread && this.state.notification.result.length === 0)
                        ? (
                            <div className={style.nothing}>
                                {T.text('without_notification')}
                            </div>
                        )
                        : null
                    }
                    { this.state.notification && renderList() }
                </div>
            </BoxScroll>
            </div>
        )
    }
}

export default UserNotifications



// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/UserNotifications/index.js